"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSourceFromChainId = exports.createWallets = exports.castToNetwork = exports.getNetworkGroup = exports.getSapphirePassportScoresInfo = exports.getBorrowContracts = exports.getCrossChainContracts = void 0;
const ethers_1 = require("ethers");
function getCrossChainContracts(chainId, networkMap) {
    const contracts = [];
    const wantTestChains = networkMap[chainId].isTestNetwork;
    // ignore the key value in .entries()
    for (const [, contract] of Object.entries(networkMap)) {
        if (contract.isTestNetwork === wantTestChains) {
            contracts.push(contract);
        }
    }
    return contracts;
}
exports.getCrossChainContracts = getCrossChainContracts;
function getBorrowContracts(chainId, networkMap) {
    const contracts = [];
    const wantTestChains = networkMap[chainId].isTestNetwork;
    // ignore the key value in .entries()
    for (const [, contract] of Object.entries(networkMap)) {
        if (contract.isTestNetwork === wantTestChains) {
            contracts.push(contract);
        }
    }
    return contracts;
}
exports.getBorrowContracts = getBorrowContracts;
function getSapphirePassportScoresInfo(contractProperties) {
    return __awaiter(this, void 0, void 0, function* () {
        const sapphirePassportScoresInfo = yield Promise.all(contractProperties.map((contractProperty) => __awaiter(this, void 0, void 0, function* () {
            const [currentEpoch, merkleRootDelayDuration, currentTimestamp, lastMerkleRootUpdate, currentMerkleRoot, upcomingMerkleRoot, isPaused,] = yield Promise.all([
                contractProperty.contract.currentEpoch(),
                contractProperty.contract.merkleRootDelayDuration(),
                contractProperty.contract.currentTimestamp(),
                contractProperty.contract.lastMerkleRootUpdate(),
                contractProperty.contract.currentMerkleRoot(),
                contractProperty.contract.upcomingMerkleRoot(),
                contractProperty.contract.isPaused(),
            ]);
            return {
                currentEpoch,
                merkleRootDelayDuration,
                currentTimestamp,
                lastMerkleRootUpdate,
                currentMerkleRoot,
                upcomingMerkleRoot,
                isPaused,
            };
        })));
        const areAllSameEpoch = sapphirePassportScoresInfo.every((info, _index, all) => {
            return info.currentEpoch.eq(all[0].currentEpoch);
        });
        const areAllAcceptingRoot = sapphirePassportScoresInfo.every((info) => {
            return info.currentTimestamp.gte(info.merkleRootDelayDuration.add(info.lastMerkleRootUpdate));
        });
        const areAllNotPaused = sapphirePassportScoresInfo.every((info) => {
            return !info.isPaused;
        });
        const areAllSameUpcomingRoot = sapphirePassportScoresInfo.every((info, _index, all) => {
            return info.upcomingMerkleRoot === all[0].upcomingMerkleRoot;
        });
        return {
            currentEpoch: sapphirePassportScoresInfo[0].currentEpoch.toNumber(),
            currentEpochDelaySecs: sapphirePassportScoresInfo[0].merkleRootDelayDuration.toNumber(),
            currentMerkleRoot: sapphirePassportScoresInfo[0].currentMerkleRoot,
            upcomingMerkleRoot: sapphirePassportScoresInfo[0].upcomingMerkleRoot,
            areAllSameEpoch: areAllSameEpoch,
            areAllAcceptingRoot: areAllAcceptingRoot,
            areAllNotPaused: areAllNotPaused,
            areAllSameUpcomingRoot: areAllSameUpcomingRoot,
        };
    });
}
exports.getSapphirePassportScoresInfo = getSapphirePassportScoresInfo;
function getNetworkGroup(chainId) {
    return chainId === '80001' || chainId === '4' ? 'testnets' : 'prodnets';
}
exports.getNetworkGroup = getNetworkGroup;
function castToNetwork(network) {
    switch (network) {
        case 'rinkeby':
            return 'rinkeby';
        case 'homestead':
            return 'homestead';
        case 'mumbai':
            return 'mumbai';
        case 'polygon':
            return 'polygon';
        default:
            return 'rinkeby';
    }
}
exports.castToNetwork = castToNetwork;
function createWallets(privateKey, providerMap) {
    return {
        1: new ethers_1.Wallet(privateKey, providerMap[1]),
        4: new ethers_1.Wallet(privateKey, providerMap[4]),
        137: new ethers_1.Wallet(privateKey, providerMap[137]),
        80001: new ethers_1.Wallet(privateKey, providerMap[80001]),
    };
}
exports.createWallets = createWallets;
function getSourceFromChainId(chainId) {
    switch (chainId) {
        case '80001':
            return 'mumbai';
        case '4':
            return 'rinkeby';
        case '1':
            return 'ethereum';
        case '137':
            return 'polygon';
        default:
            return 'unknown';
    }
}
exports.getSourceFromChainId = getSourceFromChainId;
//# sourceMappingURL=crosschain.js.map